import React from "react";
import PropTypes from "prop-types";
import filesize from "filesize";

export default class FileFieldRow extends React.Component {
    constructor(props) {
        super(props);

        this.onFileOpen = this.onFileOpen.bind(this);
        this.onFileRemove = this.onFileRemove.bind(this);
    }

    onFileOpen(e) {
        const { onFileOpen, file, index } = this.props;
        onFileOpen && onFileOpen(e, file, index);
    }

    onFileRemove(e) {
        const { onFileRemove, file, index } = this.props;
        onFileRemove && onFileRemove(e, file, index);
    }

    humanReadableFileSize(bytes) {
        return filesize(bytes);
    }

    render() {
        const {
            file,
            readOnly,
        } = this.props;
        const showProgress = file.status !== Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE;
        const isError = file.status === Hybrid.FileInfo.FILEUPLOADSTATES.ERROR;
        const style = isError ? {color: "red"} : {};
        const unique = file.id;
        return (
            <div id={`fileRow_${unique}`} className="row fileRow" style={style}>
                <div className={`col-md-${showProgress ? 6 : 10} filename`}>
                    <a id={`fileLink_${unique}`} href="#" className="file-link" style={style} onClick={this.onFileOpen}>{file.filename}</a> (<span className="file-size">{this.humanReadableFileSize(file.filesize)}</span>)
                    {isError && <div><small>The upload encountered a problem.</small></div>}
                </div>
                {showProgress && <div className="col-md-4">
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow={file.progress} aria-valuemin="0" aria-valuemax="100" style={{width: file.progress+"%"}}>
                            {file.progress}%
                        </div>
                    </div>
                </div>}
                {!readOnly && <div className="col-md-2 text-right">
                    <a id={`fileOpen_${unique}`} href="#" className="file-open" onClick={this.onFileOpen} ><span className="glyphicon glyphicon-new-window"/></a>{" "}
                    <a id={`fileRemove_${unique}`} href="#" className="file-remove" onClick={this.onFileRemove} ><span className="glyphicon glyphicon-remove-circle"/></a>
                </div>}
            </div>
        );
    }
};

FileFieldRow.propTypes = {
    onFileOpen: PropTypes.func,
    onFileRemove: PropTypes.func,
    file: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        filename: PropTypes.string.isRequired,
        progress: PropTypes.number.isRequired,
        filesize: PropTypes.number.isRequired,
        status: PropTypes.string.isRequired, //Hybrid.FileInfo.FILEUPLOADSTATES
    }),
    index: PropTypes.number.isRequired,
    readOnly: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/BaseControls/FileField/FileFieldRow.js